export const drawerBodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
};

export const separateApplicationRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};
